import React from 'react';
import { SxProps, Theme, Tooltip, Typography } from '@mui/material';
import { calculateAge, getGenderLabel } from '../../types/common';
import { formatDate } from '../../utils/dateUtils';

interface GenderAgeDisplayProps {
  genderType: string;
  birthday: string;
  showTooltip?: boolean;
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
  fontSize?: string;
  color?: string;
  fontWeight?: string | number;
  marginLeft?: string | number;
  additionalSx?: SxProps<Theme>;
}

/**
 * 性別と年齢を表示するコンポーネント
 */
const GenderAgeDisplay: React.FC<GenderAgeDisplayProps> = ({
  genderType,
  birthday,
  showTooltip = false,
  tooltipPlacement = 'top',
  fontSize = '1rem',
  color,
  fontWeight,
  marginLeft,
  additionalSx
}) => {
  // 性別が設定されていない場合の表示
  const genderText = genderType ? getGenderLabel(genderType) : '未設定';

  // 年齢表示テキストを取得
  const getAgeText = () => {
    if (!birthday) return '';
    const age = calculateAge(birthday);
    return ` (${age}歳)`;
  };

  // スタイル設定
  const typographyStyle: SxProps<Theme> = {
    fontSize,
    ...(color ? {color} : {}),
    ...(fontWeight ? {fontWeight} : {}),
    ...(marginLeft ? {marginLeft} : {}),
    ...(showTooltip ? {cursor: 'help'} : {}),
    ...(additionalSx || {})
  };

  const content = (
    <Typography component="span" sx={typographyStyle}>
      {genderText}{getAgeText()}
    </Typography>
  );

  // ツールチップ表示の有無
  if (showTooltip && birthday) {
    return (
      <Tooltip
        title={`生年月日: ${formatDate(birthday)}`}
        arrow
        placement={tooltipPlacement}
      >
        {content}
      </Tooltip>
    );
  }

  return content;
};

export default GenderAgeDisplay;
